module.exports = __webpack_public_path__ + "static/media/LIO_Topo.981901be.png";